import { Option, TableRow } from '@sam/components';
import { NavigateFunction } from 'react-router-dom';
import { AbsenceReason, Language, SimpleUser } from 'shared';
import { Right, UserRight } from 'shared/src/userRole/UserRole.types';
import i18n from '../../i18n/i18n';
import { getTranslatedName } from '../holiday/Holiday.utils';
import { getUserNameForSimpleUser, isUserAllowedToDo } from '../user/User.utils';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

/**
 * Helper Method to convert AbsenceReasons into TableRows
 * @param reasons to convert
 * @param navigate navigate method to implement in entries
 * @returns  Array of TableRows
 */
export const convertAbsenceReasonsIntoTableEntries = (
  userRights: UserRight,
  reasons: AbsenceReason[],
  simpleUsers: SimpleUser[],
  navigate: NavigateFunction,
): TableRow[] => {
  return reasons.map((reason) => ({
    id: reason.id,
    onClick: () => navigate(`/absence/reason/edit`, { state: { reason } }),
    content: [
      reason.name,
      reason.lastUpdate?.toLocaleDateString('de-DE') || '',
      getUserNameForSimpleUser(reason.updatedBy, simpleUsers),
      reason.creatingTimeTracking ? i18n.t('general.buttons.yes') : i18n.t('general.buttons.no'),
      reason.disabled
        ? i18n.t('pages.absenceReasons.overview.deactivated')
        : i18n.t('pages.absenceReasons.overview.active'),
      <div>
        {isUserAllowedToDo(userRights, Right.ABSENCE_REASON_EDIT) && (
          <IconComponent
            type={IconType.EDIT}
            width={40}
            onClick={(evt) => {
              evt.stopPropagation();
              navigate(`/absence/reason/edit`, { state: { reason } });
            }}
          />
        )}
      </div>,
    ],
  }));
};

/**
 * Util method to generate Dropdown options for absenceReasons
 * @param reasons the reasons to generate the options for
 * @param language the language to display the translation, fallback to name
 * @returns Array of options for absenceReasons
 */
export const generateDropdownOptionsForAbsenceReasons = (
  reasons: AbsenceReason[],
  language: Language | undefined,
): Option[] => {
  return reasons.map((reason) => ({
    label: getTranslatedName(reason, language),
    value: reason.id,
  }));
};
